import { render, staticRenderFns } from "./baseform.vue?vue&type=template&id=dca23358&scoped=true&"
import script from "./baseform.vue?vue&type=script&lang=js&"
export * from "./baseform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca23358",
  null
  
)

export default component.exports